export default __webpack_public_path__ + "static/media/logo.82d8b728.svg";